import { render, staticRenderFns } from "./SectorAdd.vue?vue&type=template&id=703026a6&"
import script from "./SectorAdd.vue?vue&type=script&lang=js&"
export * from "./SectorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports